import mediumZoom from "medium-zoom"

(function ($) {
	$(function () {
		
		var $links = $('.report__content a, .post__content a, .case-content a').filter(function() {
			var $a = $(this);
			var href = $a.attr('href').split('?')[0];
			var $img = $a.children('img');

			if ($img.length > 0 
				&& (href.endsWith('.jpg') 
					|| href.endsWith('.png') 
					|| href.endsWith('jpeg') 
					|| href.endsWith('.webp')
                    || href.endsWith('.svg')
				)
                && $a.closest('.swiper-slide').length === 0
			) {
				return true;
			}
			return false;
		});

		$links.on('click', function(e) {
			e.preventDefault();
		});

		var $images = $links.find('img');

		mediumZoom($images.toArray(), {
			margin: 20,
		});

        $('.b-image-slider__img-link').on('click', function(e) {
            e.preventDefault()
        })
		
	});
})(window.jQuery);
